import EmptyPlaceholder from '@/shared/Common/EmptyPlaceholder'

const ParameterCalculatedTab = () => {
  return (
    <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <EmptyPlaceholder inscription="Отсутствуют данные для отображения" />
    </div>
  )
}

export default ParameterCalculatedTab
